export default "__VITE_ASSET__CO10ipij__"